import React from 'react';
import PropTypes from 'prop-types';
import { MountableCourseCopy } from '../CourseCopy/component';
import { CourseAppearancePortal } from '../CourseAppearanceSettings/portal';
import { MountableCourseIdentityIntegrationSettings } from '../CourseIdentityIntegrationSettings/component';

export const CourseAdmin = ({ query }) => {
  const { action } = query;
  switch (action) {
    case 'advanced':
      return (
        <>
          <MountableCourseCopy />
          <MountableCourseIdentityIntegrationSettings />
        </>
      );
    case 'appearance':
      return <CourseAppearancePortal />;
    default:
      return null;
  }
};

CourseAdmin.propTypes = {
  query: {
    action: PropTypes.string,
  }.isRequired,
};
